module.exports = __webpack_public_path__ + "img/f8182270c3a24821a35be41d5cb7d6f7-1440.6f3f1b12.jpg";